<!--
  ~ Copyright (c) 2019 Signum+ Software & Facility GmbH
  ~ Author: jahn@signum-plus.at
  -->

<ng-container *ngIf="model.type === 'kit-view/component/svg-symbol'">
  <svg>
    <use [attr.xlink:href]="source"></use>
  </svg>
</ng-container>

<ng-container *ngIf="model.type === 'kit-view/component/svg-code'">
  <svg [innerHtml]="svg"></svg>
</ng-container>